/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 *
 */

/**
 * @module bulb-media/bulbmedia
 */

import { Plugin } from 'ckeditor5';

import BulbMediaUi from './bulbmediaui';

/**
 * The general insert media plugin.
 *
 * @extends Plugin
 */
export default class BulbMedia extends Plugin {

  /**
   * @inheritDoc
   */
  public static get requires() {
    return [BulbMediaUi] as const;
  }

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbMedia' as const;
  }
}
